import * as React from 'react';
import styled from 'styled-components';

import { SecondaryButton } from 'ui/button';
import { colors, spacing } from 'ui/theme';
import { body2 } from 'ui/theme/typography';
import { Tooltip } from 'ui/tooltip';
import { pxToRem } from 'utils/convert';

const StyledActionBar = styled.div`
  ${body2}
  align-items: center;
  background: ${colors.purple100};
  color: ${colors.white};
  display: flex;
  justify-content: flex-start;
  padding: ${spacing.base} ${spacing.layoutLRPadding};
  height: ${pxToRem(74)};

  > * + * {
    margin-left: ${spacing.half};
  }
`;

// TODO: [PRO-3634] `displayContent` convention for localization. Turn text to translate into a localization en-US.json
export const displayContent = {
  selected: 'selected',
};

export type Action = {
  active?: boolean;
  icon?: React.ReactNode;
  isDisabled?: boolean;
  isTooltipEnabled?: boolean;
  label: string;
  onClick: () => void;
  sortIndex: number;
  tooltipContent?: string;
};

type Props = {
  /** the list of actions that can be performed on the selected objects */
  actions: Action[];
  /** the text content to display */
  content?: {
    selected?: string;
  };
  /** The number of items the bulk action bar is acting upon */
  numSelected: number;
};

export const BulkActionsBar = ({
  actions = [],
  content = displayContent,
  numSelected,
  ...props
}: Props) => (
  <StyledActionBar data-test="bulk-action-bar" {...props}>
    <div data-test="bulk-actions-items-selected">{`${numSelected} ${content.selected}:`}</div>
    {actions
      .sort((a, b) => a.sortIndex - b.sortIndex)
      .map(({ icon, isDisabled, isTooltipEnabled, label, onClick, tooltipContent }, i) => (
        <Tooltip key={i} isEnabled={isTooltipEnabled ?? false} tooltipContent={tooltipContent}>
          <SecondaryButton key={label} isDisabled={isDisabled} onClick={onClick}>
            {icon || null}
            <span>{label}</span>
          </SecondaryButton>
        </Tooltip>
      ))}
  </StyledActionBar>
);
